export const API ={
       //devlopment side url
    BASE_URL: "http://54.193.130.43:8000/"

    //Client side url
    // BASE_URL: "http://3.101.154.87:8000/"
}  
